import type { MeResponse } from '@/js/account/shared/model';
import { accountHttp } from '@/js/account/shared/api';

export async function accountMeShow(): Promise<MeResponse> {
  const { data } = await accountHttp.get<MeResponse>('/me');
  return data;
}
